import { requestPut } from '../request';
import apiPath from '../modules/apiPath';

const api = {
  UpdatePosOrderInput(payload) {
    return requestPut(apiPath.POS_ORDER_INPUT.path, payload);
  }
};

export default api;
